import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ScriptLoaderService {
    private loadedScripts = new Set<string>();

    async processHtmlScripts(html: string): Promise<void> {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const scripts = doc.getElementsByTagName('script');

        Array.from(scripts).forEach(function (node) {
            var script = document.createElement('script');
            script.src = node.src;
            doc.body.appendChild(script);
            // doc.body.removeChild(node);
        });
        // (2) to execute directly js
        // Array.from(scripts).forEach(function (script) {
        //     eval(script.innerHTML);
        // });

        // for (const script of Array.from(scripts)) {
        //     const src = script.getAttribute('src');
        //     const type = script.getAttribute('type');
        //     const content = script.textContent;

        //     if (src) {
        //         // Externes Script
        //         await this.loadExternalScript(src, type === 'module');
        //     } else if (content) {
        //         // Inline Script
        //         await this.executeInlineScript(content, type === 'module');
        //     }
        // }


    }

    private async loadExternalScript(src: string, isModule: boolean): Promise<void> {
        if (this.loadedScripts.has(src)) return;

        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            if (isModule) script.type = 'module';
            script.onload = () => {
                this.loadedScripts.add(src);
                resolve();
            };
            script.onerror = reject;
            document.body.appendChild(script);
        });
    }

    private async executeInlineScript(content: string, isModule: boolean): Promise<void> {
        if (isModule) {
            // Für Module-Scripts einen Blob erstellen
            const blob = new Blob([content], { type: 'text/javascript' });
            const url = URL.createObjectURL(blob);
            await this.loadExternalScript(url, true);
            URL.revokeObjectURL(url);
        } else {
            // Normales Script direkt ausführen
            const script = document.createElement('script');
            script.textContent = content;
            document.body.appendChild(script);
        }
    }
}
